module.exports = __webpack_public_path__ + "static/media/malcolm-page.c6093693.jpg";